import { FlexRow } from '@editor/components/utilities/layouts';
import { h3, h5, p3, p4 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const ShowcaseItemWrapper = styled(FlexRow)`
  gap: 16px;
  padding: 16px;
  align-items: center;
  background: ${themeStyle.varBackgroundBase};
  border-radius: ${themeStyle.radiusMedium};

  ${QUERIES.largeTabletAndUp} {
    gap: 24px;
  }
`;

export const ShowcaseResponsiveImage = styled.img`
  width: 80px;
  height: 64px;

  ${QUERIES.largeTabletAndUp} {
    width: 150px;
    height: 110px;
  }
`;

export const ShowcaseTitle = styled.h3`
  ${h5};

  ${QUERIES.largeTabletAndUp} {
    ${h3};
  }
`;

export const ShowcaseDescription = styled.p`
  ${p4};

  ${QUERIES.largeTabletAndUp} {
    ${p3};
  }
`;
